// extracted by mini-css-extract-plugin
export default {"mainTitle":"ChannelLoyalty_mainTitle__sQ7SB","paragraphWrapper":"ChannelLoyalty_paragraphWrapper__WgJZa","secTitle":"ChannelLoyalty_secTitle__eDD7V"};